/**
 * The list containing the available JSON editor modes.
 */
const editorThemes = [
    "ambiance",
    "chaos",
    "chrome",
    "cloud9_day",
    "cloud9_night",
    "cloud9_night_low_color",
    "clouds",
    "clouds_midnight",
    "cloud_editor",
    "cloud_editor_dark",
    "cobalt",
    "crimson_editor",
    "dawn",
    "dracula",
    "dreamweaver",
    "eclipse",
    "github",
    "github_dark",
    "gob",
    "gruvbox",
    "gruvbox_dark_hard",
    "gruvbox_light_hard",
    "idle_fingers",
    "iplastic",
    "katzenmilch",
    "kr_theme",
    "kuroir",
    "merbivore",
    "merbivore_soft",
    "monokai",
    "mono_industrial",
    "nord_dark",
    "one_dark",
    "pastel_on_dark",
    "solarized_dark",
    "solarized_light",
    "sqlserver",
    "terminal",
    "textmate",
    "tomorrow",
    "tomorrow_night",
    "tomorrow_night_blue",
    "tomorrow_night_bright",
    "tomorrow_night_eighties",
    "twilight",
    "vibrant_ink",
    "xcode",
] as const;

export default editorThemes;
